import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../components/ScrollToTop';

function Template({ children }) {
  useEffect(() => {
    // Bootstrap'in JavaScript dosyasını dinamik olarak yükle
    const loadBootstrapJS = async () => {
      try {
        await import('bootstrap/dist/js/bootstrap.bundle.min.js');
      } catch (error) {
        console.error('Bootstrap JS yüklenemedi:', error);
      }
    };
    
    loadBootstrapJS();
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1" style={{ paddingTop: '76px', marginBottom: '20px' }}>
        {children}
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default Template;
